module.exports = __webpack_public_path__ + "img/bg1.b49e08ae.jpg";